import {
  MainContainer,
  Paginator,
  Search,
  MenuSelector,
} from "components/shared"

import * as S from "./styles"
import { usePermissions, useTranslation } from "hooks"
import { translations } from "./translations"
import { useHistory } from "react-router-dom"
import { useState } from "react"

import { GridCommercialTeam } from "components/settings/CommercialTeam"
import { useQuery } from "react-query"
import { apiGeneral } from "services"

const INITIAL_PAGE = 1

const ListCommercialTeams = () => {
  const history = useHistory()
  const { getTranslation } = useTranslation(translations)
  const { checkUserPermission } = usePermissions()
  const [search, setSearch] = useState("")
  const [page, setPage] = useState(INITIAL_PAGE)
  const { data, isLoading } = useQuery({
    queryKey: ["get-commercial-teams", search, page],
    queryFn: async () => {
      const { data } = await apiGeneral.get("/comercial-team", {
        params: {
          search: search,
          page: page,
        },
      })
      return data
    },
    keepPreviousData: true,
  })

  const handleSearchChange = (value: string) => {
    setSearch(value)
  }

  const handlePageChange = (page: number) => {
    setPage(page)
  }

  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation("configuracoes")}{" "}
          <MenuSelector page="commercial-teams" />
          {isLoading && <S.LoadingPage />}
        </h1>
        <Search onSearch={handleSearchChange} />
        {checkUserPermission("insertCommercialTeam") && (
          <S.ButtonMini
            onClick={() => history.push("/settings/commercial-team/new")}
          >
            {getTranslation("novoCommercialTeam")}
          </S.ButtonMini>
        )}
      </S.PageHeader>
      <S.PageContent>
        <GridCommercialTeam commercialTeam={data?.data ?? []} />
        <Paginator
          pagination={data?.pagination ?? {}}
          onPageChange={handlePageChange}
          loading={isLoading}
        />
      </S.PageContent>
    </MainContainer>
  )
}

export default ListCommercialTeams
